import store from '../store/configureStore'
import { showMessage } from '../actions/messagesActions'
import moment from 'moment'

export const ERROR = 'error'
export const INFO = 'info'
export const ALERT = 'alert'
export const SUCCESS = 'success'

const showMsg = (type, msgText) => {
  const dataHora = moment().format('DD/MM/YYYY HH:mm:ss')
  console.log(`${dataHora} - ${type} - ${msgText}`)
  return store.dispatch(showMessage({ type, msgText }))
}

export const showErrorMsg = (message) => showMsg(ERROR, message)

export const showInfoMsg = (message) => showMsg(INFO, message)

export const showAlertMsg = (message) => showMsg(ALERT, message)

export const showSuccessMsg = (message) => showMsg(SUCCESS, message)
